import ErrorIcon from "@assets/icons/error.svg";
import styled from "@emotion/styled";
import { AppLogo } from "@ui/components/common/app-logo";
import { ContactSupport } from "@ui/components/buttons/contact-support";
import { NetworkError } from "@ui/components/common/error";
import { stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";

export enum ErrorType {
	NETWORK = "Network",
	SERVER = "Server",
}

interface ErrorViewProps {
	refresh: () => void;
	errorType?: ErrorType;
}

export const ServerErrorView: React.FC<ErrorViewProps> = ({ refresh, errorType }) => (
	<Container>
		<HeaderContainer>
			<AppLogo height={32} width={125} />
		</HeaderContainer>
		<ContentContainer>
			<NetworkError onRefresh={refresh} icon={<ErrorIcon color={colors.grey} width={96} height={96} />} />
			{errorType === ErrorType.SERVER && <ContactSupport uiStyle="primary" />}
		</ContentContainer>
	</Container>
);

const Container = styled.div`
	height: 100vh;
	display: flex;
	flex-direction: column;
`;

const ContentContainer = styled.div`
	${stack(16, "center", "center")};
	display: flex;
	flex: 1;
`;

const HeaderContainer = styled.div`
	height: 80px;
	align-self: stretch;
	border-bottom: 1px solid ${colors.primary25};
	background-color: ${colors.white};
	display: grid;
	grid-template-columns: 128px 1fr 128px;
	place-items: center;
	padding-left: 40px;
	padding-right: 40px;
`;
